import useValidate from "../criteria/validation/useValidate";
import { criteriaGroupsType } from "../../common/types/search/search";

export const ValidationInitializer = ({
	criteria,
}: {
	criteria: criteriaGroupsType;
}) => {
	useValidate(criteria);

	return null;
};
